module.exports = __webpack_public_path__ + "img/pictogram_sad-face_96.e2e94b64.svg";